









import { Vue, Component } from "vue-property-decorator";
import { ITicket } from "@/models/tickets";
import { IUser } from "@/models/users";
import TicketForm from "@/components/app/global/tickets/ticketForm.vue";

@Component({
  components: { TicketForm }
})
export default class AdminAddUpmindTicketView extends Vue {
  public get formProps() {
    const user: IUser = this.$store.state.user;
    return {
      accountId: user?.upmind_account_id,
      brandId: user?.upmind_brand_id,
      clientId: user?.upmind_client_id,
      onSuccess: (vm: TicketForm, ticket: ITicket) => {
        return vm.$router.push({
          name: `admin__upmindTicket`,
          params: {
            ticketId: ticket.id
          }
        });
      }
    };
  }
}
